import o from "./index120.js";
import t from "./index121.js";
import e from "./index112.js";
import a from "./index122.js";
function u(r) {
  return o(r) || t(r) || e(r) || a();
}
export {
  u as default
};
